import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_malkainvestimentos.png",
      alt: "Estratégias Malka Investimentos",
    },
    title: "Opere com a Malka Investimentos.",

    // String ou array de strings
    text: [
      "Com anos de vivência no mercado, inclusive em tesouraria de Bancos, conheça a Carteira Malka Investimentos, 100% automatizada, ativa desde 2021, acumulando a média mensal de cinquenta mil pontos anuais.",
    ],
    testimonial: {
      text: "Transparência e rentabilidade norteiam a Malka Investimentos.",
      author: {
        name: "Vitor G. Head de estratégias Malka",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Portifólio Carteira Malka Investimentos",
    heading: "Carteira de estratégias avançadas à sua disposição.",
    subtitle:
      "Estratégias objetivas e com alta rentabilidade à sua disposição, desenvolvidas por operadores profissionais.",
  },

  cta: {
    title: "Pronto para ser lucrativo e ter consistência?",
    subtitle: "Ativar agora mesmo",
    // buttonText: "Ativar modo Investidor Quant!",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Malka Investimentos",
    col1: [
      "Somos uma Empresa formada por operadores especializados em Mercado Financeiro, com experiência em tesouraria e operacionais de Instituições financeiras, focados em renda variável.",
      "Nossa equipe de operadores e desenvolvedores, após suas passagens por casas financeiras, resolveram criar a Malka Investimentos, onde por anos consecutivos tiveram contas auditadas, tendo sido considerados a melhor conta auditada do Brasil por mais de três anos consecutivos. Sendo assim, desenvolveram uma carteira de estratégias vencedoras para compor a Malka Investimentos. ",
    ],
    // col2: [
    //   "Por trás de nossos algoritmos está a expertise e a experiência de mercado financeiro do nosso CEO, Victor Lago. Com anos de vivência no setor, Victor é o responsável pelo desenvolvimento e aprimoramento contínuo de nossos algoritmos, garantindo que permaneçamos na vanguarda das estratégias de investimento. ",
    // ],
  },

  stats: {
    title: "Nossos números na Malka Investimentos",
    subtitle:
      "Vasta experiência em mercado futuro operando de forma automatizada",
    data: [
      {
        value: "50k",
        description: "Média de 50 mil pontos em índice por ano",
      },
      {
        value: "+2,2M",
        description: "Mais de 2.2M em Gestão de Capital de clientes",
      },
      {
        value: "Top 1",
        description:
          "Conta auditada via mql5 como top 1 Brasil por anos consecutivos",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs do Investidor Quant?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "30 dias para testar",
        description:
          "Teste nossa estratégia e confira a performance em sua conta",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos ajustes e parametrizações da estratégia automaticamente.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte individual diretamente com os operadores",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas de nossos clientes.",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem Emocional",
        description:
          "Com a estratégia automatizada você vai acabar com todos seus problemas de tomar decisões impulsivas e irracionais",
      },
      {
        icon: iconsSet.lightning,
        title: "Velocidade",
        description:
          "Os nossos algoritmos conseguem realizar cálculos após a abertura, tomando decisões mais rápido que qualquer ser humano.",
      },
      {
        icon: iconsSet.clock,
        title: "Ganhe Tempo",
        description:
          "Você não precisa ficar na frente do computador para realizar suas operações. Após sua escolha, a automação opera por você.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "A malka investimentos mudou a minha forma de pensar, estava iniciando no mercado, e me ajudou a de fato encontrar a consistência que sempre busquei, com foco em longo prazo.",
      author: "Jair de Almeida",
      job: "Advogado",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Quando conheci a malka, foi um divisor de águas pra mim, consegui parar de perder, e de fato começar a ver grana no day trade, eles são muito profissionais e justo em tudo que fazem, trazendo sempre transparência nos negócios, o que nós deixa mais confiável para investir.",
      author: "Ricardo Motta",
      job: "Empresário",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
